// extracted by mini-css-extract-plugin
module.exports = {"title":"FuvmProgressBar_title__t9T-i","progress-bar-container":"FuvmProgressBar_progress-bar-container__1f65e","bytes":"FuvmProgressBar_bytes__2mBff"};